import React, { useEffect, useState } from "react";

const Preloader = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const markLoaded = () => {
      document.body.classList.add("loaded");
      setVisible(false);
    };

    // If page already loaded, close immediately.
    if (document.readyState === "complete") {
      markLoaded();
    } else {
      window.addEventListener("load", markLoaded, { once: true });
    }

    // Safety timeout: never let preloader block on slow mobile networks.
    const timeoutId = window.setTimeout(markLoaded, 1800);

    return () => {
      window.removeEventListener("load", markLoaded);
      window.clearTimeout(timeoutId);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
      <div className="loader-section section-left"></div>
      <div className="loader-section section-right"></div>
    </div>
  );
};

export default Preloader;
